import { GetStaticPaths, GetStaticProps } from 'next';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { Footer, Header } from '../../components';
import { getArticles, getArticlesBySlug } from '../../services/blog.service';
import menu from '../../utils/menu';
import { IPostPageProps } from './blog.types';
import PostPage from './post-page';

export default function Post({ post }: IPostPageProps) {
  const router = useRouter();

  if (router.isFallback) {
    return <p>Loading...</p>;
  }

  return (
    <>
      <Head>
        <meta property="og:title" content={post.article.meta_title} />
        <meta property="og:image" content={`${post.article?.background}`} />
        <meta name="twitter:image" content={`${post.article?.background}`} />
        <meta property="og:image:alt" content={post.article.meta_title} />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=5.0, minimum-scale=1.0"
        />
        <meta property="og:type" content="post" />
        <meta
          property="og:description"
          content={post.article.meta_description}
        />
        <meta name="description" content={post.article.meta_description} />
        <meta name="keywords" content={post.article.keywords} />
        <title>{post.article.meta_title}</title>
      </Head>
      <Header
        menu={menu}
        appearanceLogo="white"
        appearance="contained"
        appearanceNav="white"
      />
      <PostPage post={post} />
      <Footer />
    </>
  );
}

export const getStaticPaths: GetStaticPaths = async () => {
  const articles = (await getArticles()) as { id: number; slug: string }[];

  const paths: string[] = articles.map((article) => `/blog/${article.slug}`);

  return {
    paths,
    fallback: true,
  };
};

export const getStaticProps: GetStaticProps<IPostPageProps> = async ({
  params,
}) => {
  if (!params) {
    return {
      notFound: true,
    };
  }
  const { slug } = params;

  if (!slug) {
    return {
      notFound: true,
    };
  }

  try {
    const article = await getArticlesBySlug(slug as string);

    if (!article) {
      return {
        notFound: true,
      };
    }

    return {
      props: {
        post: article,
      },
      revalidate: 60,
    };
  } catch {
    return {
      notFound: true,
    };
  }
};
